var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#201D1E",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M22.99 14.714a5.852 5.852 0 1 0-.589 8.792l4.266 4.265a.781.781 0 0 0 1.104-1.104L23.506 22.4a5.85 5.85 0 0 0-.516-7.687m-7.171 1.104a4.29 4.29 0 0 1 6.07 6.064l-.003.004-.004.004a4.29 4.29 0 0 1-6.064-6.071"
  })));
};
export default SvgSearch;